import { Box, Divider, Grid } from '@mui/material';
import Item from '@mui/material/ListItem';
import { makeStyles } from 'tss-react/mui';

import moment from 'moment';

import { StatusInfo } from '@features/workspace/components/shared/status-info';
import { getBankAccountStatus } from '@utils/constants';

import {
  LulaLogoDark,
  BankLogoAbsaIcon,
  BankLogoAccessBankIcon,
  BankLogoCapitecIcon,
  BankLogoFnbIcon,
  BankLogoNedbankIcon,
  BankLogoStandardBankIcon,
} from '@app/icons';
import { useAppSelector } from '@store/hooks';
import { selectBankAccounts } from '@features/workspace/store/selectors';
import config from '@/app/configs/config';

const useStyles = makeStyles<any>()({
  header: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '18px',
  },

  date: {
    color: '#838383',
  },

  accountType: {
    color: '#B6B6B6',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '18px',
  },
});

const getBankIcon = (bankName: string): any => {
  if (bankName === 'absa') return <BankLogoAbsaIcon height={24} />;
  if (bankName === 'access_bank') return <BankLogoAccessBankIcon height={24} />;
  if (bankName === 'capitec') return <BankLogoCapitecIcon height={24} />;
  if (bankName === 'fnb') return <BankLogoFnbIcon height={24} />;
  if (bankName === 'nedbank') return <BankLogoNedbankIcon height={24} />;
  if (bankName === 'standard_bank') {
    return <BankLogoStandardBankIcon height={24} />;
  }
  if (bankName === 'lula') return <LulaLogoDark width={80} />;

  return <></>;
};

export function CustomerProductLulaBank() {
  const { classes } = useStyles(null);

  const bankAccounts = useAppSelector(selectBankAccounts);

  const properties: Array<any> = [];
  let count = 0;

  bankAccounts?.forEach(function (bankAccount: any) {
    const bankAccountIsActive = bankAccount.statusCode === '00'; // Active statusCode
    const statusComponent = (
      <StatusInfo
        showIcon
        isCompleted={bankAccountIsActive}
        text={
          bankAccountIsActive
            ? 'Active'
            : getBankAccountStatus(bankAccount.statusCode)
        }
      />
    );

    properties.push({
      id: count.toString(),
      header: bankAccount.name,
      text: bankAccount.bankAccountNumber,
      activeState: bankAccountIsActive,
      iconSource: getBankIcon('lula'),
      type: bankAccount.issuingProductCode === 'LLFREE' ? 'Free' : 'Unlimited',
      date: bankAccount.createdAt
        ? moment(bankAccount.createdAt).format(config.dateFormat)
        : '',
      component: statusComponent,
    });

    count++;
  });

  return (
    <>
      {properties.map((item) => (
        <Box key={`lula-bank-${item.id}`}>
          {item?.id !== '0' ? (
            <>
              <Divider />
            </>
          ) : (
            <></>
          )}

          <Grid container mb={0.5} mt={2} spacing={0}>
            <Grid container item className={classes.header} xs={4}>
              {item?.iconSource && (
                <Grid item ml={-3.5} mt={-0.3} xs={2}>
                  {item?.iconSource}
                </Grid>
              )}
              <Grid item ml={item?.iconSource ? 3 : 0}>
                {item?.header}
                {!!item.type && (
                  <>
                    <br />
                    <Item
                      className={classes.accountType}
                      sx={{
                        marginLeft: '-16px',
                        marginTop: '-10px',
                        wordBreak: 'keep-all',
                      }}
                    >
                      ({item.type})
                    </Item>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item className={classes.header} xs={4}>
              Acc No. {item?.text}
            </Grid>
            <Grid item alignItems="end" className={classes.header} xs={4}>
              <Box alignItems="center" display="flex" flexDirection="column">
                <Box display="flex">{item?.component}</Box>
                <Box className={classes.date} display="flex">
                  {item?.date && item?.date}
                  {!item?.date && <Item sx={{ height: '0px' }}>&nbsp;</Item>}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
}
